import React, { useState } from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import { Body1, Body2, Sub2 } from "../../../../assets/styles/Typography";
import { Button } from "../../../../assets/styles/ButtonStyle";
import images from "../../../../assets/styles/Images";
import { BoxWrap } from "../../../../assets/styles/BusinessAnalysisStyle";
import { useAtom } from "jotai";
import { 
  IS_LOGGED_IN, 
  AUTODISPLAY_CONTENT_LIST, 
  AUTODISPLAY_SENSOR_DATA,
  AUTODISPLAY_TITLE,
  AUTODISPLAY_TEXT_DATA,
  AUTODISPLAY_LOCATION_DATA,
  AUTODISPLAY_DESIGN_CONCEPT,
  AUTODISPLAY_DISPLAY_WIDTH, AUTODISPLAY_DISPLAY_HEIGHT } from "../../../AtomStates";
import PopupWrap from "../../../../assets/styles/Popup";
import OrganismDisplayViewApiPreview from "../../../Global/components/organisms/OrganismDisplayViewApiPreview";
import OrganismDisplayViewCustomPreview from "../../../Global/components/organisms/OrganismDisplayViewCustomPreview";
import MoleculeApiContentPopup from "../molecules/MoleculeApiContentPopup";
import MoleculeApiContentSettingPopup from "../molecules/MoleculeApiContentSettingPopup";
import {
  getViewApiDetailOnServer,
  getViewCustomDetailOnServer,
} from "../../../../utils/indexedDB";

const OrganismApiContentList = ({ contentList: inputContentList = [], lotationDetail = null, onLotationUpdate = null }) => {
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [, setSensorSerialData] = useAtom(AUTODISPLAY_SENSOR_DATA);
  const [title, setTitle] = useAtom(AUTODISPLAY_TITLE);
  const [textData, setTextData] = useAtom(AUTODISPLAY_TEXT_DATA);
  const [locationData, setLocationData] = useAtom(AUTODISPLAY_LOCATION_DATA);
  const [designConcept, setDesignConcept] = useAtom(AUTODISPLAY_DESIGN_CONCEPT);
  const [displayWidth, setDisplayWidth] = useAtom(AUTODISPLAY_DISPLAY_WIDTH);
  const [displayHeight, setDisplayHeight] = useAtom(AUTODISPLAY_DISPLAY_HEIGHT);

  // 미리보기 상태
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [showSensorPreview, setShowSensorPreview] = useState(false);
  const [selectedContentId, setSelectedContentId] = useState(null);

  // 삭제 팝업
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [contentToDelete, setContentToDelete] = useState(null);

  const list = inputContentList.length > 0 ? inputContentList : contentList;
  const scheduledList = Array.isArray(lotationDetail?.lotationContents)
    ? lotationDetail.lotationContents
    : [];

    const handleTemplatePreview = async (contentId, dataType) => {
      try {
        // 서버에서 최신 데이터 가져오기
        let latestContent;
        if (dataType === "sensor") {
          latestContent = await getViewCustomDetailOnServer(
            contentId,
            isLoggedIn
          );
        } else {
          latestContent = await getViewApiDetailOnServer(contentId, isLoggedIn);
        }
  
        setTextData(
          latestContent?.interviewModeType === "conceptBoard"
            ? latestContent?.selectedMessage?.text
            : latestContent?.textData
        );
        const locationData = {
          selectedRegion: latestContent?.contentData?.selectedRegion,
          selectedDistricts: latestContent?.contentData?.selectedDistricts,
        };
        setLocationData(locationData);
        setDesignConcept(latestContent?.designSelectedConcept);
        setTitle(latestContent?.contentData?.title);
  
        setDisplayWidth(parseInt(latestContent.viewDevice.deviceWidth));
        setDisplayHeight(parseInt(latestContent.viewDevice.deviceHeight));
  
        if (latestContent?.contentData?.dataType === "sensor") {
          const sensorData = {
            title: latestContent?.contentData.title,
            serialCode: latestContent?.contentData.serialCode,
          };
          setSensorSerialData(sensorData);
        }
  
        console.log("latestContentpreviewwww", latestContent);
  
        // setTemplateToPreview(contentId);
        // setShowPopup(false);
        if (latestContent?.contentData?.dataType === "sensor") {
          setShowSensorPreview(true);
        } else {
          setShowTemplatePreview(true);
        }
      } catch (error) {
        console.error("미리보기 데이터 로딩 실패:", error);
        setShowTemplatePreview(false);
      }
    };

  const handleCloseTemplatePreview = () => {
    setShowTemplatePreview(false);
    setSelectedContentId(null);
  };

  const handleCloseSensorPreview = () => {
    setShowSensorPreview(false);
    setSelectedContentId(null);
  };

  const handleDeleteContent = (contentId) => {
    setContentList((prev) => prev.filter((c) => c._id !== contentId));
    setShowConfirmPopup(false);
    setContentToDelete(null);
  };

  const [showArrangePopup, setShowArrangePopup] = useState(false);
  const [showSettingPopup, setShowSettingPopup] = useState(false);
  const [showCopySuccessPopup, setShowCopySuccessPopup] = useState(false);
  const [copiedInfo, setCopiedInfo] = useState({ type: "", content: "" });

  const handleCopyToClipboard = async (content, type) => {
    try {
      await navigator.clipboard.writeText(content);
      setCopiedInfo({ type, content });
      setShowCopySuccessPopup(true);
    } catch (error) {
      console.error("복사 실패:", error);
      setCopiedInfo({ type: "오류", content: "복사에 실패했습니다." });
      setShowCopySuccessPopup(true);
    }
  };

  return (
    <Container>
      <Header>
        <HeaderLeft>
          {lotationDetail && (
            <DirectLinkContainer>
              <StyledFrame>
                <div>
                  <StyledIdSpan01>다이렉트 링크 : </StyledIdSpan01>
                  <StyledIdSpan02
                    onClick={() => {
                      const vid = lotationDetail.viewId || lotationDetail._id;
                      const url = `http://${window.location.host}/AutodisplayViewLinkApiLotation/${vid}`;
                      window.open(url, "_blank");
                    }}
                    style={{ cursor: "pointer", textDecoration: "underline", color: "#007bff" }}
                  >
                    AutodisplayViewLinkApiLotation
                  </StyledIdSpan02>
                </div>
                <CopyButton
                  onClick={() => {
                    const vid = lotationDetail.viewId || lotationDetail._id;
                    const url = `${window.location.host}/AutodisplayViewLinkApiLotation/${vid}`;
                    handleCopyToClipboard(url, "다이렉트 링크");
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" fill="#9CA3AF"/>
                  </svg>
                </CopyButton>
              </StyledFrame>
            </DirectLinkContainer>
          )}
        </HeaderLeft>
        <HeaderRight>
          <StyledContentButton onClick={() => setShowSettingPopup(true)}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <circle cx="10" cy="10" r="1.5" fill="#256EF4" />
              <path
                d="m10 1 3 3-3 3-3-3 3-3zM10 19l3-3-3-3-3 3 3 3zM16 7l3 3-3 3-3-3 3-3zM4 13l3-3-3-3-3 3 3 3z"
                fill="#256EF4"
              />
            </svg>
            <Sub2 color="primary">콘텐츠 설정하기</Sub2>
          </StyledContentButton>
          <StyledContentButton onClick={() => setShowArrangePopup(true)}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <circle
                cx="10.11"
                cy="10.11"
                r="7.11"
                stroke="#256EF4"
                strokeWidth="1.5"
              />
              <line
                x1="9.89549"
                y1="6.4099"
                x2="9.89549"
                y2="10.1839"
                stroke="#256EF4"
                strokeWidth="1.86911"
                strokeLinecap="round"
              />
              <line
                x1="11.8236"
                y1="11.5456"
                x2="9.92994"
                y2="10.1967"
                stroke="#256EF4"
                strokeWidth="1.86911"
                strokeLinecap="round"
              />
            </svg>
            <Sub2 color="primary">콘텐츠 편성하기</Sub2>
          </StyledContentButton>
        </HeaderRight>
      </Header>

      <ContentListWrap>
        {scheduledList.length === 0 ? (
          <BoxWrap NoData style={{ height: "300px" }}>
            <img src={images.ListFillPrimary} alt="" />
            <Body2 color="gray700" align="center !important">
              편성된 콘텐츠가 없습니다.
            </Body2>
          </BoxWrap>
        ) : (
          <Table>
            <colgroup>
              <col width="40%" />
              <col width="13%" />
              <col width="12%" />
              <col width="12%" />
              <col width="13%" />
            </colgroup>
            <TableHeader>
              <tr>
                <th>
                  <Body1 color="gray700" align="left">콘텐츠 정보</Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">디스플레이</Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">제작일</Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">수정일</Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">{/* 작업 */}</Body1>
                </th>
              </tr>
            </TableHeader>
            <TableBody>
              {scheduledList.map((content) => (
                <tr key={content._id}>
                  <td>
                    <ContentNameCell>
                      <Body2 color="gray400" style={{ fontWeight: 700 }}>
                        {content.contentData?.title || content.dataAnalysis?.title}
                      </Body2>
                      <Body2 color="gray700" style={{ marginTop: 2 }}>
                        {content?.contentData?.dataType === "sensor"
                          ? `SN ${content?.contentData?.serialCode || ""} - ${
                              content?.contentData?.sensorDataName || ""
                            }`
                          : content?.contentData?.dataType || "api"}
                      </Body2>
                    </ContentNameCell>
                  </td>
                  <td>
                    <Body2
                      color="gray700"
                      align="left"
                      style={{ whiteSpace: "nowrap", textAlign: "left" }}
                    >
                      {content.viewDevice?.deviceTitle || "디스플레이"}
                    </Body2>
                  </td>
                  <td>
                    <Body2 color="gray700" align="left">
                      {(() => {
                        const dateStr = content.createDate;
                        if (!dateStr) return "-";
                        const match = dateStr.match(/^(.+?)\s+(오전|오후)\s+(.+)$/);
                        if (match) {
                          const datePart = match[1];
                          const amPm = match[2];
                          const timePart = match[3];
                          return (
                            <>
                              {datePart}
                              <br />
                              <Body2 color="gray700" align="left">
                                {amPm} {timePart}
                              </Body2>
                            </>
                          );
                        }
                        return dateStr;
                      })()}
                    </Body2>
                  </td>
                  <td>
                    <Body2 color="gray700" align="left">
                      <div style={{ textAlign: "left" }}>
                        {content.createDate === content.updateDate
                          ? "-"
                          : (() => {
                              const dateStr = content.updateDate;
                              if (!dateStr) return "-";
                              const match = dateStr.match(/^(.+?)\s+(오전|오후)\s+(.+)$/);
                              if (match) {
                                const datePart = match[1];
                                const amPm = match[2];
                                const timePart = match[3];
                                return (
                                  <div style={{ textAlign: "left" }}>
                                    {datePart}
                                    <br />
                                    <span>
                                      {amPm} {timePart}
                                    </span>
                                  </div>
                                );
                              }
                              return dateStr;
                            })()}
                      </div>
                    </Body2>
                  </td>
                  <td>
                    <ActionButtonsCell>
                      <PreviewButton
                        type="button"
                        onClick={() =>
                          handleTemplatePreview(
                            content._id,
                            content?.contentData?.dataType
                          )
                        }
                      >
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.4991 4.9375C14.2651 4.9376 17.6532 7.00578 18.712 9.81836C18.8158 10.0941 18.8308 10.4038 18.7374 10.6992C18.0917 12.7392 15.547 15.4374 10.4991 15.4375C5.43073 15.4375 2.93409 12.476 2.27936 10.7217C2.17268 10.4358 2.17158 10.1309 2.25983 9.85352C2.7197 8.40882 3.86624 7.17982 5.3194 6.32129C6.77927 5.4589 8.5994 4.9375 10.4991 4.9375ZM10.4991 6.27051C8.83591 6.27051 7.25005 6.7295 5.99713 7.46973C4.73751 8.21395 3.86349 9.2112 3.53034 10.2578L3.52936 10.2598C4.00367 11.5242 6.02377 14.1045 10.4991 14.1045C15.0269 14.1044 17.0129 11.7269 17.4659 10.2988V10.2979C17.4658 10.2964 17.4657 10.2929 17.4639 10.2881C16.6478 8.12022 13.8568 6.27061 10.4991 6.27051ZM10.4991 7.02148C12.2479 7.02148 13.666 8.43867 13.6661 10.1875C13.6661 11.9364 12.248 13.3545 10.4991 13.3545C8.75034 13.3543 7.33307 11.9363 7.33307 10.1875C7.33316 8.43878 8.75039 7.02166 10.4991 7.02148ZM10.4991 8.35449C9.48677 8.35467 8.66617 9.17516 8.66608 10.1875C8.66608 11.1999 9.48671 12.0213 10.4991 12.0215C11.5116 12.0215 12.3331 11.2 12.3331 10.1875C12.333 9.17505 11.5116 8.35449 10.4991 8.35449Z"
                            fill="#666666"
                          />
                        </svg>
                        미리보기
                      </PreviewButton>
                      {/* <DeleteButton
                        type="button"
                        onClick={() => {
                          setContentToDelete(content._id);
                          setShowConfirmPopup(true);
                        }}
                      >
                        <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_992_2924)">
                            <path
                              d="M16.8364 3.70215C17.2366 3.70215 17.5618 4.02663 17.562 4.42676C17.562 4.82711 17.2368 5.15234 16.8364 5.15234H16.4419V15.3652C16.4419 17.367 14.8196 18.9902 12.8179 18.9902H6.71533C4.71361 18.9902 3.09131 17.367 3.09131 15.3652V5.15234H2.69678C2.29664 5.1521 1.97217 4.82695 1.97217 4.42676C1.97243 4.02678 2.2968 3.70239 2.69678 3.70215H16.8364ZM4.54053 5.15234V15.3652C4.54053 16.5663 5.5143 17.54 6.71533 17.54H12.8179C14.0189 17.54 14.9927 16.5663 14.9927 15.3652V5.15234H4.54053ZM8.24854 7.12402C8.64858 7.12419 8.97289 7.44861 8.97314 7.84863V14.5791C8.97314 14.9793 8.64874 15.3045 8.24854 15.3047C7.84819 15.3047 7.52295 14.9794 7.52295 14.5791V7.84863C7.52321 7.44851 7.84835 7.12402 8.24854 7.12402ZM11.2837 7.12402C11.6839 7.12402 12.009 7.44851 12.0093 7.84863V14.5791C12.0093 14.9794 11.684 15.3047 11.2837 15.3047C10.8835 15.3045 10.5591 14.9794 10.5591 14.5791V7.84863C10.5593 7.4486 10.8836 7.12417 11.2837 7.12402ZM12.064 0.988281C12.4641 0.988474 12.7884 1.31279 12.7886 1.71289C12.7886 2.11312 12.4641 2.43828 12.064 2.43848H7.47119C7.07096 2.43834 6.74658 2.11315 6.74658 1.71289C6.74674 1.31276 7.07106 0.988422 7.47119 0.988281H12.064Z"
                              fill="#666666"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_992_2924">
                              <rect width="20" height="20" fill="white" transform="translate(0 0.1875)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </DeleteButton> */}
                    </ActionButtonsCell>
                  </td>
                </tr>
              ))}
            </TableBody>
          </Table>
        )}
      </ContentListWrap>

      {/* 삭제 확인 팝업 */}
      {showConfirmPopup && contentToDelete && (
        <PopupWrap
          Warning
          title="정말 삭제 하시겠습니까?"
          message={<>해당 콘텐츠가 삭제됩니다.</>}
          buttonType="Outline"
          closeText="취소"
          confirmText="삭제"
          isModal={false}
          onCancel={() => {
            setShowConfirmPopup(false);
            setContentToDelete(null);
          }}
          onConfirm={() => handleDeleteContent(contentToDelete)}
        />
      )}

      {/* 미리보기 */}
      {showTemplatePreview && (
        <OrganismDisplayViewApiPreview onClose={handleCloseTemplatePreview} />
      )}
      {showSensorPreview && (
        <OrganismDisplayViewCustomPreview onClose={handleCloseSensorPreview} />
      )}

      {showArrangePopup && (
        <MoleculeApiContentPopup
          onClose={() => setShowArrangePopup(false)}
          contentList={list}
          lotationDetail={lotationDetail}
          onLotationUpdate={onLotationUpdate}
        />
      )}

      {showSettingPopup && (
        <MoleculeApiContentSettingPopup
          onClose={() => setShowSettingPopup(false)}
          lotationDetail={lotationDetail}
          onUpdate={onLotationUpdate}
        />
      )}

      {showCopySuccessPopup && (
        <PopupWrap
          Check
          title="클립보드에 복사가 완료되었습니다."
          message={
            copiedInfo.type === "오류"
              ? copiedInfo.content
              : `${copiedInfo.type}가 클립보드에 복사되었습니다.`
          }
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => {
            setShowCopySuccessPopup(false);
            setCopiedInfo({ type: "", content: "" });
          }}
        />
      )}
    </Container>
  );
};

export default OrganismApiContentList;

const Container = styled.div`
  width: 1240px;
  background: white;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px 20px 0px;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;


const ContentListWrap = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  background: ${palette.white};
  // OrganismApiDashboardContentList 테이블과 동일하게 hover/보더 간격 느낌 맞춤
`;

const TableHeader = styled.thead`
  background: #eef2f7;

  th {
    padding: 16px 20px;
    border-bottom: 1px solid ${palette.outlineGray};
  }
`;

const TableBody = styled.tbody`
  tr {
    &:hover {
      background: #f9fafb;
    }
    border-bottom: 1px solid ${palette.outlineGray};
  }

  td {
    padding: 16px 20px;
  }
`;

const ContentNameCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

const ActionButtonsCell = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
`;

const PreviewButton = styled.button`
  background: ${palette.gray100};
  color: ${palette.gray700};
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover {
    background: ${palette.gray200};
  }
`;

const DeleteButton = styled.button`
  color: #666666;
  border: none;
  padding: 4px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;

  &:hover {
    svg {
      path {
        fill: rgb(73, 73, 73);
      }
    }
  }
`;

const NoDataBox = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${palette.white};
  border: 1px dashed ${palette.outlineGray};
  border-radius: 8px;
`;

const StyledContentButton = styled(Button).attrs({
  Large: true,
  PrimaryLightest: true,
  Fill: true,
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #e6f0ff !important;
  }
`;


// 다이렉트 링크 관련 스타일
const DirectLinkContainer = styled.div`
  margin-left: 0px;
`;

const StyledFrame = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
`;

const StyledIdSpan01 = styled.span`
  color: var(--color-text-subtle, #464c53);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const StyledIdSpan02 = styled.span`
  color: var(--color-text-primary, #0b50d0);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${palette.gray100};
  }
`;


